import { FormattedMessage } from 'react-intl'
import { isValidEmail } from 'utils'
import { isStaff } from '../../utils'

const requiredText = (
  <FormattedMessage
    id='required_field'
    defaultMessage='This field is required!'
  />
)

function checkoutValidation(values, isOrderEdit, isLaCheckout, phoneInstance) {
  if(isOrderEdit && isStaff()) {
    return {}
  }

  const errors = {}

  if(!isOrderEdit) {
    if(!values.firstName) {
      errors.firstName = requiredText
    }
    if(!values.lastName) {
      errors.lastName = requiredText
    }
    if(!values.email) {
      errors.email = requiredText
    } else if(values.email && !isValidEmail(values.email)) {
      errors.email = (
        <FormattedMessage
          id='error-email-length'
          defaultMessage='Invalid E-Mail'
        />
      )
    }
    if(!values.phone) {
      errors.phone = requiredText
    } else if(phoneInstance && !phoneInstance.isValidNumber()) {
      errors.phone = (
        <FormattedMessage
          id='error_phone'
          defaultMessage='Invalid Phone number'
        />
      )
    }
    if(isLaCheckout && !values.gender) {
      errors.gender = requiredText
    }
  }
  return errors
}

function createAccountValidation(values) {
  const errors = {}

  if(!values.password) {
    errors.password = requiredText
  } else if(values.password && values.password.length < 6) {
    errors.password = (
      <FormattedMessage
        id='error-pass-length'
        defaultMessage='Must be at least 6 characters long'
      />
    )
  }
  if(!values.email) {
    errors.email = requiredText
  } else if(values.email && !isValidEmail(values.email)) {
    errors.email = (
      <FormattedMessage
        id='error-email-length'
        defaultMessage='Invalid E-Mail'
      />
    )
  }
  if(!values.isTermsAccepted) {
    errors.isTermsAccepted = requiredText
  }
  return errors
}

function intentPopupValidation(values) {
  const errors = {}

  if(!values.firstName) {
    errors.firstName = requiredText
  }

  if(!values.lastName) {
    errors.lastName = requiredText
  }
  if(!values.email) {
    errors.email = requiredText
  } else if(values.email && !isValidEmail(values.email)) {
    errors.email = (
      <FormattedMessage
        id='error-email-length'
        defaultMessage='Invalid E-Mail'
      />
    )
  }
  if(!values.phone) {
    errors.phone = requiredText
  }
  if(values.createAccount) {
    if(!values.isTermsAccepted) {
      errors.isTermsAccepted = requiredText
    }

    if(!values.password) {
      errors.password = requiredText
    } else if(values.password.length < 6) {
      errors.password = (
        <FormattedMessage
          id='password-length'
          defaultMessage='password must be at least 6 characters'
        />
      )
    }
  }

  return errors
}

export { checkoutValidation, createAccountValidation, intentPopupValidation }
